import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';
import { InvoiceTask, Team } from '@/hooks/api/models';

/**
 * 2540. チームタスクスキップ設定変更
 * [PUT] /workspaces/:identifier/teams/:team_id/task_phase_skip_setting
 */
type Props = {
  identifier: string;
  team_id: number;
  quotation_task_skippable: boolean;
  sales_order_contract_task_skippable: boolean;
  invoice_task_skippable: boolean;
  purchase_order_contract_task_skippable: boolean;
  payment_task_skippable: boolean;
};

const updateTaskPhaseSkipSetting = (props: Props): Promise<Team> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/task_phase_skip_setting`, props);
};

export const useUpdateTaskPhaseSkipSetting = () => {
  return useMutation({
    mutationFn: updateTaskPhaseSkipSetting,
  });
};
